import { render, staticRenderFns } from "./SearchPop.vue?vue&type=template&id=49fb4565&scoped=true"
import script from "./SearchPop.vue?vue&type=script&lang=js"
export * from "./SearchPop.vue?vue&type=script&lang=js"
import style0 from "./SearchPop.vue?vue&type=style&index=0&id=49fb4565&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fb4565",
  null
  
)

export default component.exports